import DashboardLayout from "../components/Dashboard/Layout/DashboardLayout.vue";
// GeneralViews
import Login from "src/components/Dashboard/Views/Pages/Login.vue";
import Ingreso from "src/components/Admisiones/Ingreso.vue";
import IngresoServicios from "src/components/Admisiones/ingresoServicios.vue";
import PacientesRegistrados from "src/components/Admisiones/pacientes-registrados.vue";
import HistoriaClinica from "src/components/Historia Clinica/historia-clinica.vue";
import HistoriaClinicaMovil from "src/components/Historia Clinica/historia-clinica-movil.vue";
import MantenimientoEps from "src/components/Mantenimiento/mantenimiento-eps.vue";
import MantenimientoPatologias from "src/components/Mantenimiento/mantenimiento-patologias.vue";
import MantenimientoMotivoConsulta from "src/components/Mantenimiento/mantenimiento-motivo-consulta.vue";
import Roles from "src/components/Acceso/roles.vue";
import Usuarios from "src/components/Acceso/usuarios.vue";
// import Evoluciones from "src/components/Diario-De-Campo/evoluciones.vue";
import EvolucionesCitas from "src/components/Diario-De-Campo/evoluciones-citas.vue";
import ObjetivosLogros from "src/components/Diario-De-Campo/objetivos-logros.vue";
import ADashboard from "src/components/ADashboard/ADashboard.vue";
import gestionOrdenes from "src/components/ADashboard/gestionOrdenes.vue";
import gestionTerapias from "src/components/ADashboard/gestionTerapias.vue";


import programacionSinCalendar from "src/components/Programacion/programacion.vue";
import cancelarMasivo from "src/components/Programacion/cancelar-masivo.vue";

import mantenimientoestrategias from "src/components/mantenimiento/mantenimiento-estrategias";
import mantenimientomaterial from "src/components/mantenimiento/mantenimiento-material";

import Reportepacientes from "src/components/Reportes/Pacientes";
import ReporteOrdenes from "src/components/Reportes/Ordenes";
import ReporteMaestroV2 from "src/components/Reportes/MaestroV2";
import Autorizaciones from "src/components/Reportes/Autorizaciones";
import informeEvolucion from "src/components/Reportes/InformeEvolucion";
import ReporteProgramacion from "src/components/Reportes/Programacion";
import ReporteObjetivos from "src/components/Reportes/Objetivos";
import ReporteEvolucionesSinLogros from "src/components/Reportes/evolucionesSinLogro.vue";
import ReporteLogInformes from "src/components/Reportes/logInformes.vue";
import InformeValoraciones from "src/components/Reportes/valoraciones.vue"
import DynamicReport from "src/components/Reportes/sesionesTerapeutas.vue"
import DashboardPacientes from "src/components/Reportes/dashboardPacientes.vue"


import AsistenciaUsuarios from "../components/Reportes/asistenciaUsuario.vue";
import AsistenciaFechas from "../components/Reportes/informeSesiones.vue";
import InformeAutorizaciones from "../components/Reportes/informeAutorizaciones.vue";
import ReporteObjetivosYLogros from "../components/Reportes/objetivosLogros.vue"

// terapeutas
import MiEspacio from "src/components/ADashboard/miEspacio.vue";
import MiEspacioAdmin from "src/components/ADashboard/miEspacioAdmin";

// nomina
import gestionSalarios from "src/components/ADashboard/salarios.vue";
import gestionTarifas from "src/components/ADashboard/tarifas.vue";
import gestionDescargos from "src/components/ADashboard/descargos.vue";
import gastosFijos from "src/components/ADashboard/gastosFijos.vue"
import dashboardNomina from "src/components/ADashboard/dashboardNomina.vue";
import gastosVariables from "src/components/ADashboard/gastosVariables.vue";
import copagos from "src/components/ADashboard/copagos.vue";
import ReporteFacturacion from "../components/Reportes/reporteFacturacion.vue";

const routes = [
  {
    path: "/",
    component: Login,
    redirect: "/login"
  },
  {
    path: "/login",
    component: Login,
    redirect: "/login",
    children: [
      {
        path: "/login",
        component: Login
      }
    ]
  },
  {
    path: "/dashboard",
    component: DashboardLayout,
    redirect: "/dashboard/avanti",
    children: [
      {
        path: "/dashboard/avanti",
        name: "DashBoard",
        component: ADashboard
      },
      {
        path: "/gestion-ordenes",
        name: "Gestión de autorizaciones",
        component: gestionOrdenes
      },
      {
        path: "/mi-espacio",
        name: "Bienvenido a Mi Espacio",
        component: MiEspacio
      },
      {
        path: "/mi-espacio-admin",
        name: "Dashboard terapeutas",
        component: MiEspacioAdmin
      },
      {
        path: "/gestion-terapias",
        name: "Gestión de terapias",
        component: gestionTerapias
      },
      {
        path: "/ajustar-salarios",
        name: "Gestión de Salarios",
        component: gestionSalarios
      },
      {
        path: "/ajustar-tarifas",
        name: "Gestión de tarifas",
        component: gestionTarifas
      },
      {
        path: "/descargos",
        name: "Gestión de deducciones",
        component: gestionDescargos
      },
      {
        path: "/gastos-fijos",
        name: "Gestión de gastos fijos",
        component: gastosFijos
      },
      {
        path: "/dashboard-nomina",
        name: "Gestión de ingresos y egresos",
        component: dashboardNomina
      },
      {
        path: "/gastos-variables",
        name: "Gestión de gastos por fechas",
        component: gastosVariables
      }
    ]
  },
  {
    path: "/admisiones",
    component: DashboardLayout,
    redirect: "/admisiones/ingreso",
    children: [
      {
        path: "ingreso",
        name: "Ingreso de pacientes",
        component: Ingreso
      },
      {
        path: "pacientes",
        name: "Pacientes Registrados",
        component: PacientesRegistrados
      },
      {
        path: "servicios",
        name: "Ingreso de servicios",
        component: IngresoServicios
      },
      {
        path: "/copagos",
        name: "Gestión de copagos",
        component: copagos
      }
    ]
  },

  {
    path: "/historiaClinica",
    component: DashboardLayout,
    redirect: "/historiaClinica/historia",
    children: [
      {
        path: "historia",
        name: "Historia Clínica",
        component: HistoriaClinica
      },
      {
        path: "historia-movil",
        name: "Historia Clínica Movil",
        component: HistoriaClinicaMovil
      }
    ]
  },
  {
    path: "/mantenimiento",
    component: DashboardLayout,
    redirect: "/mantenimiento/mantenimientoEps",
    children: [
      {
        path: "mantenimientoEps",
        name: "Mantenimiento EPS",
        component: MantenimientoEps
      },
      {
        path: "mantenimientoPatologias",
        name: "Mantenimiento Patologías",
        component: MantenimientoPatologias
      },
      {
        path: "mantenimientoMc",
        name: "Mantenimiento Motivos de Consulta",
        component: MantenimientoMotivoConsulta
      },
      {
        path: "mantenimientoEs",
        name: "Mantenimiento Estrategías Ter.",
        component: mantenimientoestrategias
      },
      {
        path: "mantenimientoMat",
        name: "Mantenimiento Material de apoyo",
        component: mantenimientomaterial
      }
    ]
  },

  {
    path: "/acceso",
    component: DashboardLayout,
    redirect: "/acceso/usuario",
    children: [
      {
        path: "usuario",
        name: "Usuario",
        component: Usuarios
      },
      {
        path: "roles",
        name: "Roles",
        component: Roles
      }
    ]
  },
  {
    path: "/diarioCampo",
    component: DashboardLayout,
    redirect: "/diarioCampo/evoluciones",
    children: [
      // {
      //   path: "evoluciones-citas",
      //   name: "Evoluciones",
      //   component: Evoluciones
      // },
      {
        path: "evoluciones",
        name: "Evoluciones",
        component: EvolucionesCitas
      },
      {
        path: "objetivos-y-logros",
        name: "Objetivos y Logros",
        component: ObjetivosLogros
      }
    ]
  },

  {
    path: "/programacion",
    component: DashboardLayout,
    redirect: "/programacion/programacion-citas",
    children: [
      {
        path: "programacion-citas",
        name: "Programar Citas Médicas",
        component: programacionSinCalendar
      },
      {
        path: "cancelar-masivo",
        name: "Cancelar citas masivamente",
        component: cancelarMasivo
      }
    ]
  },

  {
    path: "/reportes",
    component: DashboardLayout,
    redirect: "/reportes/pacientes",
    children: [
      {
        path: "pacientes",
        name: "Reporte de pacientes",
        component: Reportepacientes
      },
      {
        path: "ordenes",
        name: "Consolidado de ordenes medicas",
        component: ReporteOrdenes
      },
      {
        path: "maestro",
        name: "Reporte maestro",
        component: ReporteMaestroV2
      },
      {
        path: "autorizaciones",
        name: "Reporte de autorizaciones",
        component: Autorizaciones
      },
      {
        path: "informeEvolucion",
        name: "Informes",
        component: informeEvolucion
      },
      {
        path: "cancelaciones",
        name: "Reporte de cancelaciones",
        component: ReporteProgramacion
      },
      {
        path: "objetivos-y-logros",
        name: "Reporte de objetivos y logros",
        component: ReporteObjetivos
      },
      {
        path: "asistencia-usuarios",
        name: "Asistencia por usuarios",
        component: AsistenciaUsuarios
      },
      {
        path: "asistencia-por-fecha",
        name: "Asistencia por fecha",
        component: AsistenciaFechas
      },
      {
        path: "informe-autorizaciones",
        name: "Informe de autorizaciones",
        component: InformeAutorizaciones
      },
      {
        path: "objetivos-logros",
        name: "Reporte de objetivos y logros",
        component: ReporteObjetivosYLogros
      },
      {
        path: "evoluciones-sin-logro",
        name: "Reporte de evoluciones sin logro de objetivo",
        component: ReporteEvolucionesSinLogros
      },
      {
        path: "registro-informes",
        name: "Informes entregados a pacientes",
        component: ReporteLogInformes
      },
      {
        path: "valoraciones",
        name: "Valoraciones",
        component: InformeValoraciones
      },
      {
        path: "sesiones-terapeuticas",
        name: "Sesiones Terapéuticas",
        component: DynamicReport
      },
      {
        path: "dashboard-pacientes",
        name: "Dashboard Pacientes",
        component: DashboardPacientes
      },
      {
        path: "reporte-facturacion",
        name: "Reporte para facturacion",
        component: ReporteFacturacion
      }
      


      // InformeAutorizaciones
    ]
  }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js